// extracted by mini-css-extract-plugin
module.exports = {"blogPost":"blog-post-module--blog-post--2nvQZ","guxMarkdown":"blog-post-module--gux-markdown--14btt"};